import * as esriLoader from 'esri-loader';

import { Interceptor } from './classes/interceptor';
import { LayerExtender } from './classes/mclayer';
import { MapExtender } from './classes/mcmap';
import { MapViewExtender } from './classes/mcMapView';

export abstract class ESRI {
    public static async loadModules<T extends any[]>(...modules: string[]): Promise<T> {
        await Interceptor.addInterceptor();
        return await esriLoader.loadModules(modules, window.esriConfig) as T;
    }

    public static get esriStylesUrl() { return esriLoader.loadCss(window.esriConfig.version).href; }

    // Start Getters

    /**
     * Get ESRI AreaMeasurement2D ['esri/widgets/AreaMeasurement2D']
     */
    public static get AreaMeasurement2D() { return this.getter<__esri.AreaMeasurement2DConstructor>('esri/widgets/AreaMeasurement2D'); }

    /**
     * Get ESRI AreaMeasurement2DViewModel ['esri/widgets/AreaMeasurement2D/AreaMeasurement2DViewModel']
     */
    public static get AreaMeasurement2DViewModel() { return this.getter<__esri.AreaMeasurement2DViewModelConstructor>('esri/widgets/AreaMeasurement2D/AreaMeasurement2DViewModel'); }

    /**
     * Get ESRI Basemap ['esri/Basemap']
     */
    public static get Basemap() { return this.getter<__esri.BasemapConstructor>('esri/Basemap'); }

    /**
     * Get ESRI Bing Maps Layer ['esri/layers/BingMapsLayer']
     */
    public static get BingMapsLayer() { return this.getter<__esri.BingMapsLayerConstructor>('esri/layers/BingMapsLayer'); }

    /**
     * Get ESRI BasemapGallery ['esri/widgets/BasemapGallery']
     */
    public static get BasemapGallery() { return this.getter<__esri.BasemapGalleryConstructor>('esri/widgets/BasemapGallery'); }

    /**
     * Get ESRI Map ['esri/config']
     */
    public static get Config() { return this.getter<__esri.config>('esri/config'); }

    /**
     * Get ESRI Draw ['esri/views/draw/Draw']
     */
    public static get Draw() { return this.getter<__esri.DrawConstructor>('esri/views/draw/Draw'); }

    /**
     * Get ESRI DistanceMeasurement2D ['esri/widgets/DistanceMeasurement2D']
     */
    public static get DistanceMeasurement2D() { return this.getter<__esri.DistanceMeasurement2DConstructor>('esri/widgets/DistanceMeasurement2D'); }

    /**
     * Get ESRI DistanceMeasurement2DViewModel ['esri/widgets/DistanceMeasurement2D/DistanceMeasurement2DViewModel']
     */
    public static get DistanceMeasurement2DViewModel() { return this.getter<__esri.DistanceMeasurement2DViewModelConstructor>('esri/widgets/DistanceMeasurement2D/DistanceMeasurement2DViewModel'); }

    /**
     * Get ESRI Expand ['esri/widgets/Expand']
     */
    public static get Expand() { return this.getter<__esri.ExpandConstructor>('esri/widgets/Expand'); }

    /**
     * Get ESRI Extent ['esri/geometry/Extent']
     */
    public static get Extent() { return this.getter<__esri.ExtentConstructor>('esri/geometry/Extent'); }

    /**
     * Get ESRI Featurelayer ['esri/layers/FeatureLayer']
     */
    public static get FeatureLayer() { return this.getter<__esri.FeatureLayerConstructor>('esri/layers/FeatureLayer'); }

    /**
     * Get ESRI Geometry Engine ['esri/geometry/geometryEngine']
     */
    public static get GeometryEngine() { return this.getter<__esri.geometryEngine>('esri/geometry/geometryEngine'); }

    /**
     * Get ESRI Geometry Engine Async ['esri/geometry/geometryEngineAsync']
     */
    public static get GeometryEngineAsync() { return this.getter<__esri.geometryEngineAsync>('esri/geometry/geometryEngineAsync'); }

    /**
     * Get ESRI GeometryService ['esri/tasks/GeometryService']
     */
    public static get GeometryService() { return this.getter<__esri.GeometryServiceConstructor>('esri/tasks/GeometryService'); }

    /**
     * Get ESRI AreasAndLengthsParameters ['esri/rest/support/AreasAndLengthsParameters']
     */
    public static get AreasAndLengthsParameters() { return this.getter<__esri.supportAreasAndLengthsParametersConstructor>('esri/rest/support/AreasAndLengthsParameters'); }

    /**
     * Get ESRI LengthsParameters ['esri/rest/support/LengthsParameters']
     */
    public static get LengthsParameters() { return this.getter<__esri.supportLengthsParametersConstructor>('esri/rest/support/LengthsParameters'); }

    /**
     * Get ESRI QueryTask ['eesri/tasks/support/Query']
     */
    public static get Query() { return this.getter<__esri.QueryConstructor>('esri/tasks/support/Query'); }

    /**
     * Get ESRI QueryTask ['esri/tasks/QueryTask']
     */
    public static get QueryTask() { return this.getter<__esri.QueryTaskConstructor>('esri/tasks/QueryTask'); }

    /**
     * Get ESRI Geoprocessor ['esri/tasks/Geoprocessor']
     */
    public static get Geoprocessor() { return this.getter<__esri.GeoprocessorConstructor>('esri/tasks/Geoprocessor'); }

    /**
     * Get ESRI Graphic ['esri/Graphic']
     */
    public static get Graphic() { return this.getter<__esri.GraphicConstructor>('esri/Graphic'); }

    /**
     * Get ESRI GraphicsLayer ['esri/layers/GraphicsLayer']
     */
    public static get GraphicsLayer() { return this.getter<__esri.GraphicsLayerConstructor>('esri/layers/GraphicsLayer'); }

    /**
     * Get ESRI Point ['esri/geometry/Point']
     */
    public static get Point() { return this.getter<__esri.PointConstructor>('esri/geometry/Point'); }

    /**
     * Get ESRI Multipoint ['esri/geometry/Multipoint']
     */
    public static get Multipoint() { return this.getter<__esri.MultipointConstructor>('esri/geometry/Multipoint'); }

    /**
     * Get ESRI Polyline ['esri/geometry/Polyline']
     */
    public static get Polyline() { return this.getter<__esri.PolylineConstructor>('esri/geometry/Polyline'); }

    /**
     * Get ESRI Sketch Widget ['esri/widgets/Sketch']
     */
    public static get Sketch() { return this.getter<__esri.SketchConstructor>('esri/widgets/Sketch'); }

    /**
     * Get ESRI Sketch Widget ['esri/widgets/Sketch/SketchViewModel']
     */
    public static get SketchViewModel() { return this.getter<__esri.SketchViewModelConstructor>('esri/widgets/Sketch/SketchViewModel'); }

    /**
     * Get ESRI MapImagelayer ['esri/layers/MapImageLayer']
     */
    public static get MapImageLayer() { return this.getter<__esri.MapImageLayerConstructor>('esri/layers/MapImageLayer'); }

    /**
     * Get ESRI Request ['esri/request']
     */
    public static get Request() { return this.getter<__esri.request>('esri/request'); }

    /**
     * Get ESRI Request ['esri/core/urlUtils']
     */
    public static get urlUtils() { return this.getter<__esri.urlUtils>('esri/core/urlUtils'); }

    /**
     * Get ESRI Request ['esri/rest/route']
     */
    public static get route() { return this.getter<__esri.route>('esri/rest/route'); }

    /**
     * Get ESRI Request ['esri/rest/support/RouteParameters']
     */
    public static get RouteParameters() { return this.getter<__esri.RouteParametersConstructor>('esri/rest/support/RouteParameters'); }

    /**
     * Get ESRI Project Paramters ['esri/tasks/support/ProjectParameters']
     */
    public static get ProjectParameters() { return this.getter<__esri.ProjectParametersConstructor>('esri/tasks/support/ProjectParameters'); }

    /**
     * Get ESRI Request ['esri/rest/support/FeatureSet']
     */
    public static get FeatureSet() { return this.getter<__esri.supportFeatureSetConstructor>('esri/rest/support/FeatureSet'); }

    /**
     * Get ESRI SimpleRenderer ['esri/renderers/SimpleRenderer']
     */
    public static get SimpleRenderer() { return this.getter<__esri.SimpleRendererConstructor>('esri/renderers/SimpleRenderer'); }

    /**
     * Get ESRI HeatmapRenderer ['esri/renderers/HeatmapRenderer']
     */
    public static get HeatmapRenderer() { return this.getter<__esri.HeatmapRendererConstructor>('esri/renderers/HeatmapRenderer'); }

    /**
     * Get ESRI SpatialReference ['esri/geometry/SpatialReference']
     */
    public static get SpatialReference() { return this.getter<__esri.SpatialReferenceConstructor>('esri/geometry/SpatialReference'); }

    /**
     * Get ESRI Sublayer ['esri/layers/support/Sublayer']
     */
    public static get Sublayer() { return this.getter<__esri.SublayerConstructor>('esri/layers/support/Sublayer'); }

    /**
     * Get ESRI Sublayer ['esri/layers/GroupLayer']
     */
    public static get GroupLayer() { return this.getter<__esri.GroupLayerConstructor>('esri/layers/GroupLayer'); }

    /**
     * Get ESRI SimpleMarkerSymbol ['esri/symbols/SimpleMarkerSymbol']
     */
    public static get SimpleMarkerSymbol() { return this.getter<__esri.SimpleMarkerSymbol>('esri/symbols/SimpleMarkerSymbol'); }

    /**
     * Get ESRI IdentifyTask ['esri/rest/identify']
     */
    public static get IdentifyTask() { return this.getter<__esri.identify>('esri/rest/identify'); }

    /**
     * Get ESRI IdentifyParameters ['esri/rest/support/IdentifyParameters']
     */
    public static get IdentifyParameters() { return this.getter<__esri.supportIdentifyParametersConstructor>('esri/rest/support/IdentifyParameters'); }

    /**
     * Get ESRI Popup ['esri/widgets/Popup']
     */
    public static get Popup() { return this.getter<__esri.PopupConstructor>('esri/widgets/Popup'); }

    /**
     * Get ESRI PopupTemplate ['esri/PopupTemplate']
     */
    public static get PopupTemplate() { return this.getter<__esri.PopupTemplateConstructor>('esri/PopupTemplate'); }

    /**
     * Get ESRI WebTileLayer ['esri/layers/WebTileLayer']
     */
    public static get WebTileLayer() { return this.getter<__esri.WebTileLayerConstructor>('esri/layers/WebTileLayer'); }

    /**
     * Get ESRI TileLayer ['esri/layers/TileLayer']
     */
    public static get TileLayer() { return this.getter<__esri.TileLayerConstructor>('esri/layers/TileLayer'); }

    /**
     * Get ESRI Polygon ['esri/geometry/Polygon']
     */
    public static get Polygon() { return this.getter<__esri.PolygonConstructor>('esri/geometry/Polygon'); }

    /**
     * Get ESRI Circle ['esri/geometry/Circle']
     */
    public static get Circle() { return this.getter<__esri.CircleConstructor>('esri/geometry/Circle'); }

    /**
     * Get ESRI WebMercatorUtils ['esri/geometry/webMercatorUtils']
     */
    public static get WebMercatorUtils() { return this.getter<__esri.webMercatorUtils>('esri/geometry/support/webMercatorUtils'); }

    /**
     * Get ESRI color ['esri/Color']
     */
    public static get Color() { return this.getter<__esri.ColorConstructor>('esri/Color'); }

    /**
     * Get ESRI color ['esri/smartMapping/symbology/color']
     */
    public static get SymbologyColor() { return this.getter<__esri.symbologyColor>('esri/smartMapping/symbology/color'); }

    /**
     * Get ESRI histogram ['esri/smartMapping/statistics/histogram']
     */
    public static get Histogram() { return this.getter<__esri.histogram>('esri/smartMapping/statistics/histogram'); }

    /**
     * Get ESRI Classed color slider ['esri/widgets/smartMapping/ClassedColorSlider']
     */
    public static get ClassedColorSlider() { return this.getter<__esri.ClassedColorSliderConstructor>('esri/widgets/smartMapping/ClassedColorSlider'); }

    /**
     * Get ESRI Class breaks renderer ['esri/renderers/ClassBreaksRenderer']
     */
    public static get ClassBreaksRenderer() { return this.getter<__esri.ClassBreaksRendererConstructor>('esri/renderers/ClassBreaksRenderer'); }

    /**
     * Get ESRI Unique value renderer ['esri/renderers/UniqueValueRenderer']
     */
    public static get UniqueValueRenderer() { return this.getter<__esri.UniqueValueRendererConstructor>('esri/renderers/UniqueValueRenderer'); }

    /**
     * Get ESRI VisualVariable object['esri/renderers/visualVariables/VisualVariable]
     */
    public static get VisualVariable() { return this.getter<__esri.VisualVariableConstructor>('esri/renderers/visualVariables/VisualVariable'); }

    /**
     * Get simple marker symbol ['esri/symbols/simpleMarker']
     */
    public static get SimpleMarker() { return this.getter<__esri.SimpleMarkerSymbolConstructor>('esri/symbols/SimpleMarkerSymbol'); }

    /**
     * Get picture marker symbol ['esri/symbols/pictureMarker']
     */
    public static get PictureMarker() { return this.getter<__esri.PictureMarkerSymbolConstructor>('esri/symbols/PictureMarkerSymbol'); }
    /**
     * Get simple line symbol ['esri/symbols/simpleLine']
     */
    public static get SimpleLine() { return this.getter<__esri.SimpleLineSymbolConstructor>('esri/symbols/SimpleLineSymbol'); }

    /**
     * Get simple fill symbol ['esri/symbols/simpleFill']
     */
    public static get SimpleFill() { return this.getter<__esri.SimpleFillSymbolConstructor>('esri/symbols/SimpleFillSymbol'); }

    /**
     * Get picture fill symbol ['esri/symbols/pictureFill']
     */
    public static get PictureFill() { return this.getter<__esri.PictureFillSymbolConstructor>('esri/symbols/PictureFillSymbol'); }

    /**
     * Get text symbol ['esri/symbols/textSymbol']
     */
    public static get TextSymbol() { return this.getter<__esri.TextSymbolConstructor>('esri/symbols/TextSymbol'); }

    /**
     * Get ESRI Simple Renderer ['esri/rest/print']
     */
    public static get Print() { return this.getter<__esri.print>('esri/rest/print'); }

    /**
     * Get ESRI Simple Renderer ['esri/rest/support/PrintParameters']
     */
    public static get PrintParameters() { return this.getter<__esri.supportPrintParametersConstructor>('esri/rest/support/PrintParameters'); }

    /**
     * Get ESRI Simple Renderer ['esri/rest/support/PrintTemplate']
     */
    public static get PrintTemplate() { return this.getter<__esri.supportPrintTemplateConstructor>('esri/rest/support/PrintTemplate'); }

    /**
     * Get ESRI JsonUtils ['esri/symbols/support/jsonUtils']
     */
    public static get JsonUtils() { return this.getter<__esri.jsonUtils>('esri/symbols/support/jsonUtils'); }

    /**
     * Get ESRI SymbolUtils ['esri/symbols/support/symbolUtils']
     */
    public static get SymbolUtils() { return this.getter<__esri.symbolUtils>('esri/symbols/support/symbolUtils'); }

    /**
     * Get ESRI PromiseUtils ['esri/core/promiseUtils']
     */
    public static get PromiseUtils() { return this.getter<__esri.promiseUtils>('esri/core/promiseUtils'); }

    /**
     * Get ESRI watchUtils ['esri/core/watchUtils']
     */
    public static get watchUtils() { return this.getter<__esri.watchUtils>('esri/core/watchUtils'); }

    /**
     * Get ESRI Coordinate widget ['esri/widgets/CoordinateConversion']
     */
    public static get CoordinateWidget() { return this.getter<__esri.CoordinateConversionConstructor>('esri/widgets/CoordinateConversion'); }

    /**
     * Get ESRI Coordinate widget view model ['esri/widgets/CoordinateConversion/CoordinateConversionViewModel']
     */
    public static get CoordinateWidgetViewModel() { return this.getter<__esri.CoordinateConversionViewModelConstructor>('esri/widgets/CoordinateConversion/CoordinateConversionViewModel'); }

    /**
     * Get ESRI Coordinate widget ['esri/geometry/coordinateFormatter']
     */
    public static get CoordinateFormatter() { return this.getter<__esri.coordinateFormatter>('esri/geometry/coordinateFormatter'); }

    /**
     * Get ESRI ScaleBar widget ['esri/widgets/ScaleBar']
     */
    public static get ScaleBarWidget() { return this.getter<__esri.ScaleBarConstructor>('esri/widgets/ScaleBar'); }

    /*
     * Get ESRI Format ['esri/widgets/CoordinateConversion/support/Format']
     */
    public static get Format() { return this.getter<__esri.FormatConstructor>('esri/widgets/CoordinateConversion/support/Format'); }

    /**
     * Get ESRI GeodesicUtils ['esri/geometry/support/geodesicUtils']
     */
    public static get GeodesicUtils() { return this.getter<__esri.geodesicUtils>('esri/geometry/support/geodesicUtils'); }

    /**
     * Get PortalItem ['esri/portal/PortalItem']
     */
    public static get PortalItem() { return this.getter<__esri.PortalItemConstructor>('esri/portal/PortalItem'); }

    // Custom Classes
    public static get MCLayer() { return LayerExtender.construct(); }

    /**
     * Get MapCore Extended ESRI Map ['esri/Map']
     */
    public static get MCMap() { return MapExtender.construct(); }

    /**
     * Get MapCore Extended ESRI Map View ['esri/views/MapView']
     */
    public static get MCMapView() { return MapViewExtender.construct(); }
    // End Getters

    private static getter<T>(moduleLocation: string): Promise < T > {
    return(async () => (await ESRI.loadModules(moduleLocation))[0] as T) ();
    }
}
